define('apps/course-intro/views/intro',[
    'apps/course-intro/templates/intro',
    'apps/course-intro/views/regions/header',
    'apps/course-intro/views/regions/nav',
    'apps/course-intro/views/regions/modules/content',
    'apps/course-intro/views/regions/levels/content',
    'apps/course-intro/views/regions/materials/content',
    'apps/course-intro/views/regions/badges/content',
    'apps/course-intro/routes/router',
    'components/user-data/main'
], function (template, HeaderView, NavView, ModulesView, LevelsView, MaterialsView, BadgesView, Router, userData) {
    "use strict";

    return Mn.LayoutView.extend({

        "initialize": function(){
            this.Controller = Mn.Controller.extend({
                "chooseLevels": this.renderLevels.bind(this),
                "chooseModules": this.renderModules.bind(this),
                "doMaterials": this.renderMaterials.bind(this),
                "getBadges": this.renderBadges.bind(this)
            });
        },

        "template": template,

        "regions": {
            "header": ".header-region",
            "nav": ".nav-region",
            "content": ".content-region"
        },

        "events": {
            "click [data-nav='route']": "route"
        },

        "updateTheme": function(level){
            var $mainRegion = $('.region-main').removeClass('level-1 level-2 level-3');
            if (typeof level !== 'undefined'){
                $mainRegion.addClass('level-' + level);
            }
        },

        "route": function(e){
            e.preventDefault();
            this.router.navigate(e.currentTarget.hash.replace('#', ''), {"trigger": true});
        },

        "renderLevels": function () {
            this.updateTheme();

            this.applyRouteData('levels');

            this.showChildView('header', new HeaderView({
                "model": this.model
            }));

            this.getRegion('nav').empty();

            this.showChildView('content', new LevelsView({
                "model": this.model
            }));
        },

        "renderMaterials": function (levelNum, levelGuid) {
            this.updateTheme(levelNum);

            this.applyRouteData('materials', levelNum, levelGuid);

            this.showChildView('header', new HeaderView({
                "model": this.model
            }));

            this.showChildView('nav', new NavView({
                "model": this.model
            }));

            this.showChildView('content', new MaterialsView({
                "model": this.model
            }));
        },

        "renderBadges": function (levelNum, levelGuid) {
            var level,
                moduleList,
                updateUnlockedBadgeData,
                launchBadgeView,
                fetchBadgeList;

            this.updateTheme(levelNum);

            this.applyRouteData('badges', levelNum, levelGuid);

            this.showChildView('header', new HeaderView({
                "model": this.model
            }));

            this.showChildView('nav', new NavView({
                "model": this.model
            }));

            level = this.model.get('levels').findWhere({
                "_id": levelGuid
            });

            this.$('.loading-overlay').removeClass('hide');


            fetchBadgeList = _.bind(function () {
                moduleList = level.get('modules');

                $.ajax({
                    "context": this,
                    "dataType": "json",
                    "headers": {
                        "X-Requested-With": "XMLHttpRequest"
                    },
                    "type": "GET",
                    "url": "/api/v1.0/learning_module/unlocked-badges?module_list=" + moduleList.pluck('_id').join(','),
                    "xhrFields": {
                        "withCredentials": true
                    },
                    "success": updateUnlockedBadgeData
                });
            }, this);


            updateUnlockedBadgeData = function (badgeList) {
                moduleList.each(function (module) {
                    var isBadgeEarned = badgeList[module.get('_id')];

                    if (!isBadgeEarned) {
                        return;
                    }

                    module.set('isBadgeEarned', isBadgeEarned);
                });
            };


            launchBadgeView = _.bind(function () {
                this.showChildView('content', new BadgesView({
                    "model": level
                }));

                this.$('.loading-overlay').addClass('hide');
            }, this);


            level.set('levelNum', levelNum)
                .fetch()
                .done(fetchBadgeList)
                .complete(launchBadgeView);
        },

        "renderModules": function (levelNum, levelGuid) {
            var level;

            this.updateTheme(levelNum);

            this.applyRouteData('modules', levelNum, levelGuid);

            this.showChildView('header', new HeaderView({
                "model": this.model
            }));

            this.showChildView('nav', new NavView({
                "model": this.model
            }));

            level = this.model.get('levels').findWhere({
                "_id": levelGuid
            });

            this.$('.loading-overlay').removeClass('hide');

            level.set('levelNum', levelNum)
                .fetch()
                .done(_.bind(function () {
                    this.showChildView('content', new ModulesView({
                        "model": level
                    }));

                    this.$('.loading-overlay').addClass('hide');
                }, this));
        },

        "applyRouteData": function (page, levelNum, levelGuid) {
            var routeData = {
                "isLevels": page === 'levels',
                "isModules": page === 'modules',
                "isBadges": page === 'badges',
                "isMaterials": page === 'materials'
            };

            levelNum = levelNum || 0;
            levelGuid = levelGuid || '';

            _.extend(routeData, {
                "show-user": routeData.isLevels,
                "show-level": !routeData.isLevels,
                "levelGuid": levelGuid,
                "levelNum": levelNum,
                "isStudent": userData.user.isStudent
            });

            this.model.set("currentPage", routeData);
        },

        "onRender": function(){
            this.router = new Router({
                "controller": new this.Controller()
            });

            Backbone.history.start();
        },

        "onShow": function() {
            this.$('.materials-page-content').trigger('load.completed');
        }
    });
});

